import React from "react";
import ColorInput from "../../Atom/Input/Color";

const Color = ({ customComponent, onChange, isActive, isDisabled, value }) => {
	const addColor = color => {
		if (onChange) onChange(color);
	};

	return (
		<>
			<button
				className={`editor-menu-item position-relative${
					isActive ? " is-active" : ""
				}`}
				style={{
					color: value
				}}
				title="Text Colour"
				type="button"
				disabled={isDisabled}>
				<ColorInput
					color={value}
					onChange={addColor}
					width="20px"
					height="20px"
					customComponent={customComponent}
				/>
			</button>
		</>
	);
};

export default Color;
